import * as React from "react"
import { Box } from "@mui/material"
import Image from "next/image"

export default function EmptyMessage({
  small,
  message = "No data found",
  type,
}: {
  small?: boolean
  message?: string
  type?:
    | "error"
    | "chart"
    | "graph"
    | "construction"
    | "emptyInbox"
    | "timeline"
    | "columns"
    | "integration-shopify"
}) {
  let content = (
    <svg
      width={small ? "112" : "151"}
      height={small ? "105" : "140"}
      viewBox="0 0 151 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="76" cy="70" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
      <path
        d="M16.5 58.5H109.5V119.5H19C17.6193 119.5 16.5 118.381 16.5 117V58.5Z"
        fill="white"
        stroke="#E5E5E5"
      />
      <path
        d="M134.732 58.5L150.066 35.5H57.5344L41.5 58.1158V58.5H134.732Z"
        fill="#FAFAF9"
        stroke="#E5E5E5"
      />
      <path
        d="M16.2676 58.5L0.934259 35.5H93.4656L109.5 58.1158V58.5H16.2676Z"
        fill="white"
        stroke="#E5E5E5"
      />
      <path
        d="M109.5 58.5H134.5V117C134.5 118.381 133.381 119.5 132 119.5H109.5V58.5Z"
        fill="#FAFAF9"
        stroke="#E5E5E5"
      />
      <rect
        x="110"
        y="60"
        width="24"
        height="28"
        fill="url(#paint0_linear_175:1542)"
      />
      <path
        d="M121.087 79.1938L109.841 58.5H134.703L146.258 79.7612C146.439 80.0944 146.198 80.5 145.818 80.5H123.284C122.368 80.5 121.525 79.9988 121.087 79.1938Z"
        fill="white"
        stroke="#E5E5E5"
      />
      <line
        x1="26"
        y1="99"
        x2="54"
        y2="99"
        stroke="#E5E5E5"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26"
        y1="103"
        x2="54"
        y2="103"
        stroke="#F5F5F5"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="26"
        y1="107"
        x2="48"
        y2="107"
        stroke="#F5F5F5"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_175:1542"
          x1="122"
          y1="60"
          x2="122"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5E5E5" />
          <stop offset="1" stopColor="#FAFAF9" />
        </linearGradient>
      </defs>
    </svg>
  )

  if (type === "error") {
    content = (
      <svg
        width={small ? "112" : "151"}
        height={small ? "105" : "140"}
        viewBox="0 0 151 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="76" cy="70" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
        <rect
          x="15.617"
          y="47.617"
          width="114.766"
          height="75.2766"
          rx="3.08511"
          fill="white"
          stroke="#E5E5E5"
          strokeWidth="1.23404"
        />
        <path
          d="M18.7021 47.617H127.298C129.002 47.617 130.383 48.9983 130.383 50.7021V57.4894H15.617V50.7021C15.617 48.9983 16.9983 47.617 18.7021 47.617Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
          strokeWidth="1.23404"
        />
        <circle cx="21.7872" cy="52.5532" r="1.85106" fill="#D4D4D4" />
        <circle cx="27.9574" cy="52.5532" r="1.85106" fill="#E5E5E5" />
        <path
          d="M83.3181 98.4154C83.3181 98.4154 82.2455 94.376 72.648 94.3558C63.0505 94.3357 62 98.3707 62 98.3707"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="63"
          y1="81.5579"
          x2="63"
          y2="85.0579"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="83"
          y1="85.0579"
          x2="83"
          y2="81.5579"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M96 34.5L96.7918 38.2245"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M113.5 38.5L111.147 41.5411"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="105.716"
          y1="33.2193"
          x2="104.414"
          y2="38.2341"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    )
  }

  if (type === "columns") {
    content = (
      <Box p={1} height="100%" width="100%" position="relative">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 499 217"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="61.0398"
            y="3"
            width="437.96"
            height="1"
            rx="0.5"
            fill="#F5F5F5"
          />
          <rect
            x="61.0398"
            y="47"
            width="437.96"
            height="1"
            rx="0.5"
            fill="#F5F5F5"
          />
          <rect
            x="61.0398"
            y="135"
            width="437.96"
            height="1"
            rx="0.5"
            fill="#F5F5F5"
          />
          <rect
            x="61.0398"
            y="179"
            width="437.96"
            height="1"
            rx="0.5"
            fill="#F5F5F5"
          />
          <rect
            x="64.0917"
            y="200"
            width="52.6468"
            height="8"
            rx="3"
            fill="#F5F5F5"
          />
          <rect
            x="159.466"
            y="200"
            width="52.6468"
            height="8"
            rx="3"
            fill="#F5F5F5"
          />
          <rect
            x="254.841"
            y="200"
            width="52.6467"
            height="8"
            rx="3"
            fill="#F5F5F5"
          />
          <rect
            x="350.216"
            y="200"
            width="52.6468"
            height="8"
            rx="3"
            fill="#F5F5F5"
          />
          <rect
            x="445.59"
            y="200"
            width="52.6468"
            height="8"
            rx="3"
            fill="#F5F5F5"
          />
          <rect width="52.6468" height="6" rx="3" fill="#F5F5F5" />
          <rect y="44" width="52.6468" height="6" rx="3" fill="#F5F5F5" />
          <rect y="132" width="52.6468" height="6" rx="3" fill="#F5F5F5" />
          <rect y="176" width="52.6468" height="6" rx="3" fill="#F5F5F5" />
          <rect y="88" width="52.6468" height="6" rx="3" fill="#F5F5F5" />
          <rect
            x="61.0398"
            y="91"
            width="437.96"
            height="1"
            rx="0.5"
            fill="#F5F5F5"
          />
          <path
            d="M78 35.5H103C104.381 35.5 105.5 36.6193 105.5 38V178.5H75.5V38C75.5 36.6193 76.6193 35.5 78 35.5Z"
            fill="#F5F5F5"
            stroke="#E5E5E5"
          />
          <path
            d="M173 114.5H198C199.381 114.5 200.5 115.619 200.5 117V178.5H170.5V117C170.5 115.619 171.619 114.5 173 114.5Z"
            fill="#F5F5F5"
            stroke="#E5E5E5"
          />
          <path
            d="M268 84.5H293C294.381 84.5 295.5 85.6193 295.5 87V178.5H265.5V87C265.5 85.6193 266.619 84.5 268 84.5Z"
            fill="#F5F5F5"
            stroke="#E5E5E5"
          />
          <path
            d="M364 151.5H389C390.381 151.5 391.5 152.619 391.5 154V178.5H361.5V154C361.5 152.619 362.619 151.5 364 151.5Z"
            fill="#F5F5F5"
            stroke="#E5E5E5"
          />
          <path
            d="M459 170.5H484C485.381 170.5 486.5 171.619 486.5 173V178.5H456.5V173C456.5 171.619 457.619 170.5 459 170.5Z"
            fill="#F5F5F5"
            stroke="#E5E5E5"
          />
        </svg>
      </Box>
    )
  }

  if (type === "integration-shopify") {
    content = (
      <svg
        width="300"
        height="300"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="101" cy="99" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
        <circle cx="101" cy="99" r="90.35" stroke="#E5E5E5" strokeWidth="1.3" />
        <rect
          x="8.5"
          y="44.5"
          width="121"
          height="79.4681"
          rx="2.5"
          fill="white"
          stroke="#E5E5E5"
        />
        <path
          d="M11 44.5H127C128.381 44.5 129.5 45.6193 129.5 47V55.1809H8.5V47C8.5 45.6193 9.61929 44.5 11 44.5Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
        />
        <circle cx="15.1383" cy="49.8404" r="1.94681" fill="#D4D4D4" />
        <circle cx="21.6277" cy="49.8404" r="1.94681" fill="#E5E5E5" />
        <line
          x1="40.6489"
          y1="71.0532"
          x2="86.9681"
          y2="71.0532"
          stroke="#E5E5E5"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="40.1489"
          y1="76.7448"
          x2="61.5106"
          y2="76.7448"
          stroke="#F5F5F5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="24" cy="72" r="6" fill="#E5E5E5" />
        <circle cx="24" cy="108" r="6" fill="#E5E5E5" />
        <line
          x1="24"
          y1="81"
          x2="24"
          y2="99"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="24"
          y1="117"
          x2="24"
          y2="134"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M180.376 129.553C180.334 129.25 180.07 129.082 179.85 129.064C179.632 129.046 175.36 128.981 175.36 128.981C175.36 128.981 171.788 125.512 171.435 125.159C171.082 124.806 170.393 124.912 170.125 124.992C170.122 124.994 169.454 125.2 168.331 125.548C168.143 124.939 167.866 124.19 167.472 123.438C166.2 121.011 164.337 119.727 162.087 119.724C162.083 119.724 162.082 119.724 162.079 119.724C161.922 119.724 161.767 119.739 161.611 119.752C161.544 119.672 161.478 119.594 161.408 119.518C160.427 118.469 159.17 117.958 157.664 118.003C154.758 118.086 151.863 120.185 149.516 123.914C147.865 126.537 146.608 129.833 146.252 132.385C142.914 133.419 140.58 134.141 140.529 134.158C138.844 134.687 138.791 134.739 138.571 136.327C138.408 137.527 134 171.611 134 171.611L170.939 178L186.949 174.02C186.949 174.02 180.417 129.856 180.376 129.553ZM166.481 126.121C165.631 126.384 164.664 126.684 163.615 127.008C163.593 125.537 163.419 123.489 162.733 121.72C164.938 122.138 166.024 124.633 166.481 126.121ZM161.682 127.607C159.746 128.207 157.634 128.861 155.515 129.517C156.111 127.235 157.241 124.962 158.629 123.473C159.145 122.918 159.868 122.301 160.723 121.948C161.527 123.626 161.702 126.001 161.682 127.607ZM157.722 119.937C158.405 119.922 158.979 120.072 159.47 120.395C158.684 120.803 157.925 121.389 157.213 122.153C155.367 124.133 153.952 127.208 153.388 130.174C151.628 130.719 149.907 131.253 148.322 131.742C149.323 127.073 153.236 120.067 157.722 119.937Z"
          stroke="#D4D4D4"
        />
        <path
          d="M162.067 137.297L160.207 144.254C160.207 144.254 158.133 143.31 155.675 143.465C152.069 143.693 152.031 145.966 152.068 146.537C152.264 149.649 160.449 150.328 160.908 157.615C161.269 163.348 157.867 167.27 152.965 167.58C147.08 167.951 143.841 164.48 143.841 164.48L145.088 159.177C145.088 159.177 148.349 161.637 150.959 161.472C152.663 161.364 153.273 159.977 153.211 158.997C152.955 154.939 146.29 155.178 145.869 148.51C145.514 142.899 149.199 137.212 157.331 136.7C160.464 136.498 162.067 137.297 162.067 137.297Z"
          fill="white"
          stroke="#D4D4D4"
        />
        <path
          d="M179.911 129.133C179.693 129.115 175.421 129.05 175.421 129.05C175.421 129.05 171.849 125.581 171.496 125.228C171.365 125.097 171.186 125.028 171 125L171.002 178.066L187.01 174.088C187.01 174.088 180.478 129.926 180.437 129.623C180.395 129.32 180.129 129.151 179.911 129.133Z"
          stroke="#D4D4D4"
        />
        <rect
          x="60.5"
          y="90.5"
          width="55"
          height="50"
          rx="3.5"
          fill="#FAFAF9"
          stroke="#E5E5E5"
        />
        <path
          d="M82 119L85.4395 115.56C85.7208 115.279 86.1023 115.121 86.5 115.121C86.8977 115.121 87.2792 115.279 87.5605 115.56L91 119H82ZM89.5 117.5L90.6895 116.31C90.9708 116.029 91.3523 115.871 91.75 115.871C92.1477 115.871 92.5292 116.029 92.8105 116.31L94 117.5H89.5ZM89.5 113H89.5075H89.5ZM83.5 122H92.5C92.8978 122 93.2794 121.842 93.5607 121.561C93.842 121.279 94 120.898 94 120.5V111.5C94 111.102 93.842 110.721 93.5607 110.439C93.2794 110.158 92.8978 110 92.5 110H83.5C83.1022 110 82.7206 110.158 82.4393 110.439C82.158 110.721 82 111.102 82 111.5V120.5C82 120.898 82.158 121.279 82.4393 121.561C82.7206 121.842 83.1022 122 83.5 122Z"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="48" cy="172" r="5.5" fill="#FAFAF9" stroke="#E5e5e5" />
        <path
          d="M52 19.5L57 20L55.5 24.5"
          stroke="#E5E5E5"
          strokeLinecap="round"
        />
        <path
          d="M185.512 59.5419L184.473 64.4583L180.163 62.4794"
          stroke="#E5E5E5"
          strokeLinecap="round"
        />
        <path
          d="M96.5 192L92 189L96.5 186.5"
          stroke="#E5E5E5"
          strokeLinecap="round"
        />
        <circle cx="161" cy="29" r="17.5" fill="#FAFAF9" stroke="#E5e5e5" />
        <path
          d="M159.236 32.4307C158.294 32.408 157.295 32.135 156.638 31.5817C155.944 31.0057 155.613 30.1121 155.613 29.2936V21.4509C156.695 21.4433 157.709 21.8405 158.46 22.7579C159.275 23.753 159.192 24.8529 159.236 26.1565C159.236 26.2399 159.229 28.2167 159.236 32.4307ZM159.236 32.4307C159.302 33.6433 159.715 34.8113 160.789 35.5678C161.578 36.1238 162.526 36.0906 163.421 36.0906C164.017 36.0906 166.403 36.0906 167 36.0906C166.934 34.8856 166.788 33.707 165.706 32.9535C164.95 32.4266 164.412 32.4307 163.408 32.4457L159.236 32.4307Z"
          stroke="#E5E5E5"
          strokeWidth="1.62669"
          strokeMiterlimit="3"
          strokeLinecap="round"
        />
      </svg>
    )
  }

  if (type === "timeline") {
    content = (
      <svg
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="70" cy="70" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
        <rect
          x="10.5"
          y="21.5"
          width="121"
          height="79.4681"
          rx="2.5"
          fill="white"
          stroke="#E5E5E5"
        />
        <path
          d="M13 21.5H129C130.381 21.5 131.5 22.6193 131.5 24V32.1809H10.5V24C10.5 22.6193 11.6193 21.5 13 21.5Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
        />
        <circle cx="17.1383" cy="26.8404" r="1.94681" fill="#D4D4D4" />
        <circle cx="23.6277" cy="26.8404" r="1.94681" fill="#E5E5E5" />
        <line
          x1="42.6489"
          y1="48.0532"
          x2="88.9681"
          y2="48.0532"
          stroke="#E5E5E5"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="42.1489"
          y1="53.7447"
          x2="63.5106"
          y2="53.7447"
          stroke="#F5F5F5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="26" cy="49" r="6" fill="#E5E5E5" />
        <circle cx="26" cy="85" r="6" fill="#E5E5E5" />
        <line
          x1="26"
          y1="58"
          x2="26"
          y2="76"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="26"
          y1="94"
          x2="26"
          y2="111"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect
          x="46.5"
          y="75.5"
          width="72"
          height="50"
          rx="3.5"
          fill="#FAFAF9"
          stroke="#E5E5E5"
        />
        <path
          d="M72 106L77.7325 100.267C78.2013 99.7988 78.8371 99.5355 79.5 99.5355C80.1629 99.5355 80.7987 99.7988 81.2675 100.267L87 106H72ZM84.5 103.5L86.4825 101.517C86.9513 101.049 87.5871 100.786 88.25 100.786C88.9129 100.786 89.5487 101.049 90.0175 101.517L92 103.5H84.5ZM84.5 96H84.5125H84.5ZM74.5 111H89.5C90.163 111 90.7989 110.737 91.2678 110.268C91.7366 109.799 92 109.163 92 108.5V93.5C92 92.837 91.7366 92.2011 91.2678 91.7322C90.7989 91.2634 90.163 91 89.5 91H74.5C73.837 91 73.2011 91.2634 72.7322 91.7322C72.2634 92.2011 72 92.837 72 93.5V108.5C72 109.163 72.2634 109.799 72.7322 110.268C73.2011 110.737 73.837 111 74.5 111Z"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (type === "construction") {
    content = (
      <svg
        width="151"
        height="140"
        viewBox="0 0 151 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="76" cy="70" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
        <rect
          x="17.617"
          y="44.617"
          width="114.766"
          height="75.2766"
          rx="3.08511"
          fill="white"
          stroke="#E5E5E5"
          strokeWidth="1.23404"
        />
        <path
          d="M20.7021 44.617H129.298C131.002 44.617 132.383 45.9983 132.383 47.7021V54.4894H17.617V47.7021C17.617 45.9983 18.9983 44.617 20.7021 44.617Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
          strokeWidth="1.23404"
        />
        <circle cx="23.7872" cy="49.5532" r="1.85106" fill="#D4D4D4" />
        <circle cx="29.9574" cy="49.5532" r="1.85106" fill="#E5E5E5" />
        <path
          d="M86.6216 70.4422C88.6114 67.6696 92.9849 69.4392 92.4868 72.8153C92.4118 73.3225 92.4577 73.8402 92.6206 74.3262C92.7835 74.8123 93.0589 75.253 93.4243 75.6126C93.7898 75.9721 94.2349 76.2403 94.7236 76.3952C95.2123 76.5502 95.7306 76.5876 96.2365 76.5044C99.6038 75.9517 101.446 80.2953 98.707 82.3327C98.2958 82.6383 97.9626 83.0366 97.7344 83.4953C97.5061 83.9539 97.3894 84.46 97.3935 84.9722C97.3977 85.4845 97.5226 85.9886 97.7583 86.4435C97.9939 86.8984 98.3335 87.2912 98.7496 87.5902C101.522 89.5799 99.7526 93.9534 96.3765 93.4553C95.8693 93.3804 95.3516 93.4262 94.8656 93.5891C94.3795 93.752 93.9388 94.0274 93.5792 94.3929C93.2197 94.7583 92.9515 95.2035 92.7966 95.6921C92.6416 96.1808 92.6042 96.6991 92.6874 97.205C93.2401 100.572 88.8965 102.415 86.8591 99.6755C86.5535 99.2644 86.1552 98.9311 85.6965 98.7029C85.2379 98.4747 84.7318 98.3579 84.2196 98.362C83.7073 98.3662 83.2032 98.4912 82.7483 98.7268C82.2934 98.9624 81.9006 99.3021 81.6016 99.7181C79.6119 102.491 75.2384 100.721 75.7365 97.345C75.8114 96.8379 75.7656 96.3202 75.6027 95.8341C75.4398 95.348 75.1644 94.9073 74.7989 94.5478C74.4335 94.1882 73.9883 93.9201 73.4997 93.7651C73.011 93.6101 72.4927 93.5727 71.9868 93.6559C68.6194 94.2087 66.7768 89.865 69.5163 87.8277C69.9274 87.522 70.2607 87.1237 70.4889 86.6651C70.7171 86.2064 70.8339 85.7004 70.8298 85.1881C70.8256 84.6758 70.7006 84.1718 70.465 83.7169C70.2294 83.262 69.8897 82.8691 69.4737 82.5702C66.7011 80.5804 68.4706 76.2069 71.8468 76.705C72.3539 76.78 72.8716 76.7341 73.3577 76.5712C73.8438 76.4083 74.2845 76.1329 74.644 75.7675C75.0036 75.402 75.2717 74.9569 75.4267 74.4682C75.5817 73.9795 75.6191 73.4612 75.5359 72.9553C74.9832 69.588 79.3268 67.7453 81.3641 70.4848C82.6772 72.2549 85.3344 72.2339 86.6216 70.4422Z"
          fill="#FAFAF9"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.364 87.2054C88.8004 88.5984 87.7065 89.7105 86.3229 90.2969C84.9393 90.8834 83.3795 90.8962 81.9864 90.3326C80.5934 89.769 79.4814 88.675 78.8949 87.2915C78.3084 85.9079 78.2956 84.3481 78.8592 82.955C79.4229 81.562 80.5168 80.4499 81.9003 79.8635C83.2839 79.277 84.8438 79.2642 86.2368 79.8278C87.6298 80.3914 88.7419 81.4854 89.3284 82.8689C89.9148 84.2525 89.9276 85.8124 89.364 87.2054V87.2054Z"
          fill="#FAFAF9"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.5164 77.1964C56.9535 75.3946 59.5168 75.3946 59.954 77.1964C60.0195 77.4671 60.1481 77.7185 60.3292 77.9301C60.5103 78.1417 60.7388 78.3076 60.9962 78.4142C61.2535 78.5208 61.5323 78.5652 61.81 78.5436C62.0877 78.5221 62.3564 78.4353 62.5942 78.2903C64.1775 77.3257 65.9907 79.1379 65.0261 80.7222C64.8813 80.9599 64.7947 81.2285 64.7732 81.506C64.7517 81.7835 64.796 82.0621 64.9025 82.3193C65.009 82.5764 65.1747 82.8049 65.386 82.9859C65.5974 83.167 65.8485 83.2957 66.119 83.3614C67.9209 83.7986 67.9209 86.3619 66.119 86.799C65.8483 86.8646 65.5969 86.9932 65.3853 87.1743C65.1737 87.3554 65.0078 87.5839 64.9012 87.8412C64.7946 88.0985 64.7503 88.3774 64.7718 88.655C64.7933 88.9327 64.8801 89.2014 65.0251 89.4392C65.9897 91.0226 64.1775 92.8357 62.5932 91.8712C62.3555 91.7264 62.0869 91.6397 61.8094 91.6182C61.5319 91.5968 61.2533 91.6411 60.9961 91.7475C60.739 91.854 60.5106 92.0197 60.3295 92.2311C60.1484 92.4424 60.0197 92.6935 59.954 92.964C59.5168 94.7659 56.9535 94.7659 56.5164 92.964C56.4508 92.6933 56.3223 92.4419 56.1412 92.2303C55.96 92.0187 55.7315 91.8528 55.4742 91.7462C55.2169 91.6396 54.9381 91.5953 54.6604 91.6168C54.3827 91.6383 54.114 91.7251 53.8762 91.8701C52.2929 92.8347 50.4797 91.0226 51.4442 89.4382C51.589 89.2005 51.6757 88.932 51.6972 88.6545C51.7187 88.377 51.6743 88.0983 51.5679 87.8412C51.4614 87.584 51.2957 87.3556 51.0844 87.1745C50.873 86.9934 50.6219 86.8648 50.3514 86.799C48.5495 86.3619 48.5495 83.7986 50.3514 83.3614C50.6221 83.2959 50.8735 83.1673 51.0851 82.9862C51.2967 82.8051 51.4626 82.5766 51.5692 82.3193C51.6758 82.0619 51.7201 81.7831 51.6986 81.5054C51.6771 81.2277 51.5903 80.959 51.4453 80.7212C50.4807 79.1379 52.2929 77.3247 53.8772 78.2893C54.8992 78.9132 56.2332 78.3611 56.5164 77.1964Z"
          fill="#FAFAF9"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.3136 85.0802C61.3136 85.8966 60.9893 86.6796 60.412 87.2569C59.8346 87.8342 59.0516 88.1586 58.2352 88.1586C57.4188 88.1586 56.6358 87.8342 56.0584 87.2569C55.4811 86.6796 55.1568 85.8966 55.1568 85.0802C55.1568 84.2637 55.4811 83.4807 56.0584 82.9034C56.6358 82.3261 57.4188 82.0018 58.2352 82.0018C59.0516 82.0018 59.8346 82.3261 60.412 82.9034C60.9893 83.4807 61.3136 84.2637 61.3136 85.0802V85.0802Z"
          fill="#FAFAF9"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1843 31.1639L13.647 32.5177M23.0196 31.7882L22.3895 33.0725M29.5326 39.1843L28.1788 39.647M6.51776 47.0495L5.16395 47.5122M7.07247 38.307L5.78823 37.677"
          stroke="#E5E5E5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (type === "chart") {
    content = (
      <svg
        width={small ? "112" : "151"}
        height={small ? "105" : "140"}
        viewBox="0 0 151 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="76" cy="70" r="69.5" fill="#FAFAF9" stroke="#E5E5E5" />
        <rect
          x="43.5"
          y="22.5"
          width="93"
          height="61"
          rx="2.5"
          fill="white"
          stroke="#E5E5E5"
        />
        <path
          d="M46 22.5H134C135.381 22.5 136.5 23.6193 136.5 25V30.5H43.5V25C43.5 23.6193 44.6193 22.5 46 22.5Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
        />
        <circle cx="48.5" cy="26.5" r="1.5" fill="#D4D4D4" />
        <circle cx="53.5" cy="26.5" r="1.5" fill="#E5E5E5" />
        <path
          d="M52 56L62.8451 48.3846L72 53L86.5 43.5L103.7 48.3846L129 38"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect
          x="16.5"
          y="59.5"
          width="93"
          height="61"
          rx="2.5"
          fill="white"
          stroke="#E5E5E5"
        />
        <path
          d="M19 59.5H107C108.381 59.5 109.5 60.6193 109.5 62V67.5H16.5V62C16.5 60.6193 17.6193 59.5 19 59.5Z"
          fill="#F5F5F5"
          stroke="#E5E5E5"
        />
        <circle cx="21.5" cy="63.5" r="1.5" fill="#D4D4D4" />
        <circle cx="26.5" cy="63.5" r="1.5" fill="#E5E5E5" />
        <path
          d="M63 94C63 90.4734 61.964 87.0244 60.0208 84.0815C58.0775 81.1386 55.3125 78.8313 52.0693 77.4463C48.826 76.0613 45.2473 75.6595 41.7777 76.2908C38.308 76.9221 35.1003 78.5587 32.5528 80.9975L39.5543 88.3114C40.6689 87.2445 42.0723 86.5284 43.5902 86.2522C45.1082 85.976 46.6739 86.1518 48.0928 86.7578C49.5117 87.3637 50.7214 88.3731 51.5716 89.6607C52.4218 90.9482 52.875 92.4571 52.875 94H63Z"
          fill="#E5E5E5"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M32.5528 80.9974C30.1901 83.2592 28.4884 86.1219 27.6304 89.278L37.4008 91.9341C37.7762 90.5533 38.5207 89.3009 39.5543 88.3114L32.5528 80.9974Z"
          fill="#E5E5E5"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M27.6304 89.2781C26.6379 92.9289 26.821 96.7997 28.1537 100.341L37.6297 96.774C37.0467 95.2249 36.9666 93.5314 37.4008 91.9342L27.6304 89.2781Z"
          fill="#E5E5E5"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M28.1537 100.341C29.0796 102.8 30.5329 105.028 32.4117 106.866C34.2904 108.704 36.5489 110.109 39.0285 110.981C41.5081 111.853 44.1485 112.171 46.7643 111.913C49.3801 111.656 51.9077 110.828 54.1695 109.489L49.0117 100.777C48.0221 101.362 46.9163 101.724 45.7719 101.837C44.6275 101.95 43.4723 101.811 42.3875 101.429C41.3027 101.048 40.3146 100.433 39.4926 99.6289C38.6707 98.8247 38.0348 97.8502 37.6297 96.774L28.1537 100.341Z"
          fill="#E5E5E5"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M54.1695 109.489C56.8598 107.897 59.0889 105.631 60.6373 102.915C62.1857 100.199 63 97.1264 63 94H52.875C52.875 95.3678 52.5187 96.712 51.8413 97.9002C51.1639 99.0885 50.1887 100.08 49.0116 100.777L54.1695 109.489Z"
          fill="#E5E5E5"
          stroke="white"
          strokeWidth="2"
        />
        <line
          x1="71"
          y1="89"
          x2="99"
          y2="89"
          stroke="#E5E5E5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="71"
          y1="93"
          x2="99"
          y2="93"
          stroke="#F5F5F5"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="71"
          y1="97"
          x2="93"
          y2="97"
          stroke="#F5F5F5"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    )
  }

  if (type === "graph") {
    content = (
      <Box p={1.5} height="100%" width="100%" position="relative">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 654 257"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="80" y="5" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <rect x="80" y="49" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <rect x="80" y="93" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <rect x="80" y="181" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <rect x="80" y="225" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <rect x="84" y="246" width="69" height="8" rx="3" fill="#F5F5F5" />
          <rect x="209" y="246" width="69" height="8" rx="3" fill="#F5F5F5" />
          <rect x="334" y="246" width="69" height="8" rx="3" fill="#F5F5F5" />
          <rect x="459" y="246" width="69" height="8" rx="3" fill="#F5F5F5" />
          <rect x="584" y="246" width="69" height="8" rx="3" fill="#F5F5F5" />
          <rect y="2" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect y="46" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect y="90" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect y="178" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect y="222" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect y="134" width="69" height="6" rx="3" fill="#F5F5F5" />
          <rect x="80" y="137" width="574" height="1" rx="0.5" fill="#F5F5F5" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119.5 224.5L242 152.5L364.5 164L493.5 137.5L620 80.5V226H117V224.5H119.5Z"
            fill="url(#paint0_linear_182:1750)"
          />
          <path
            d="M119.5 224.5L242 152.5L364.5 164L493.5 137.5L619.5 80.5"
            stroke="#E5E5E5"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_182:1750"
              x1="368.5"
              y1="80.5"
              x2="368.5"
              y2="226"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F5F5F5" />
              <stop offset="1" stopColor="#F5F5F5" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    )
  }

  if (type === "emptyInbox") {
    content = (
      <Box sx={{ py: 10 }}>
        <Image
          src="/emptyinbox.png"
          alt="empty inbox loading image"
          width={200}
          height={200}
        />
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      {content}
      <Box fontSize="xs" color="gray.500" mt={1}>
        {message}
      </Box>
    </Box>
  )
}
